// extracted by mini-css-extract-plugin
module.exports = {"alert":"it","alertIcon":"iu","formContainer":"iv","formContainerInner":"iw","successIcon":"ix","footer":"iy","footerItem":"iz"};